import DataStore from "./data-store";
import { base_url } from "../services/constants";
import CartService from "./cart-service";
import _ from 'lodash';
import Vue from 'vue';

export default {
	getTicketAsync,
	mergePayable,
	listenToTicketPayments,
	stopListening,
};

function mergePayable(into, from) {
	// will marge: payments, OrderState, OrderId
	let payments = markAndSortNewTicketPayments(into.payments, from && from.payments);
	delete into.payments;
	if (from) {
		delete from.payments;
	}
	// _.merge(into, from);
	// merge menually new values, because if it overwrites some objects (shop, client,...) that need preprocessing before merging
	// in DataStore.normalizeXXX(), so we'll just not merge them
	if (from && !_.isUndefined(from.OrderState)) {
		into.OrderState = from.OrderState;
	}
	if (from && !_.isUndefined(from.OrderId) && !into.OrderId) {
		into.OrderId = from.OrderId;
	}
	if (from && !_.isUndefined(from.Remain)) {
		into.Remain = from.Remain;
		// vue.set ?
	}
	Vue.set(into,'payments', payments);
	return into;
}

function getTicketAsync(ticketId, ShopId) {
	// '' means dont display error msg
	return DataStore.get(base_url + "/admin/ticket/ticket?TicketId=" + ticketId + '&ShopId=' + ShopId,'');
}

function markAndSortNewTicketPayments(old_tp, new_tp) {
	let payments = _.keyBy(old_tp, "id");
	for (let i in new_tp) {
		let p = new_tp[i];
		if (!payments[p.id] || payments[p.id].isNew) {
			p.isNew = true;
		}
		// do not lose info from older payment that is not provided by (like using_card, for example)
		payments[p.id] = _.merge(payments[p.id], p);
	}
	return _.sortBy(payments, "id");
}

function isPending(payment) {
	return payment.PaymentState == CartService.PAYMENT_STATES.PAYMENT_PENDING;
}

function isAuthorized(payment) {
	return [CartService.PAYMENT_STATES.PAYMENT_CAPTURED,CartService.PAYMENT_STATES.PAYMENT_AUTHORIZED].includes(payment.PaymentState);
}

function listenToTicketPayments(ticket, go) {
	let delay = 15000;
	let intervalId = setInterval(() => {
		let lastPayment = _(ticket.payments)
			.filter(p => !isPending(p))
			.maxBy("id");
		// let lastId = (lastPayment && lastPayment.id) || 0;
		let url =
			base_url +
			"/admin/ticket/ticket?ShopId=" + ticket.ShopId +
			(ticket.id ? "&id=" + ticket.id : "&TicketId=" + ticket.TicketId)
			// (lastId ? "&LastId=" + lastId : "");
		DataStore.get(url,'').then(data => {
			if (data.ticket.payments.length) {
				mergePayable(ticket, data.ticket);
				// dont move stages from here: we dont know whre we are in the checkout ladder
				// let p = _.maxBy(ticket.payments,(payment)=>payment.id)
				// if (isAuthorized(p)) {
				// 	go();
				// }
			}
		});
	}, delay);
	return intervalId;
}

function stopListening(intervalId) {
	console.log("stop listening");
	clearInterval(intervalId);
}
